import { render, staticRenderFns } from "./TrendIcon.vue?vue&type=template&id=b590e932&scoped=true&"
import script from "./TrendIcon.vue?vue&type=script&lang=js&"
export * from "./TrendIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrendIcon.vue?vue&type=style&index=0&id=b590e932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b590e932",
  null
  
)

export default component.exports